import React from 'react';
import PropTypes from 'prop-types';
import ConnectedDataDarkForm from './ConnectedDataDarkForm';

// TODO: Move to react-viewerbase

function DataDarkRouting({ match }) {
  // TODO: Figure out which filters we want to pass in via a URL
  //const { patientId } = match.params;

  return <ConnectedDataDarkForm />;
}

DataDarkRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default DataDarkRouting;
